export default __webpack_public_path__ + "static/media/wot_dain.49a7b390.jpg";